import find from 'lodash/find'

export const mapStateToPlaceOrderDetails = (state) => {
  const entities = state.entities;
  const shippingAddress = find(entities.Addresses, a => a.Id === entities.SelectedShippingAddressId);
  const billingAddress = (state.ui.useShippingForBilling)
    ? shippingAddress
    : find(entities.Addresses,
        address =>
          address.Id === entities.SelectedBillingAddressId
          && entities.BillingAddresses.includes(address.Id));
  const shippingOption = entities.ShippingOptions.filter(so => so.Id === entities.SelectedShippingOptionId)[0];
  return {
    SelectedShippingAddressId: shippingAddress && shippingAddress.Id || '',
    SelectedBillingAddressId: billingAddress && billingAddress.Id || '',
    SelectedShippingOptionId: shippingOption && shippingOption.Id || '',
    SelectedPayment: {
      Id: entities.SelectedPaymentOptionId,
      BraintreePaymentNonce: entities.PaymentRecord.BraintreePaymentNonce
    },
    BillingEqualsShipping: state.ui.useShippingForBilling,
    CouponCode: state.entities.CouponCode,
    UserIsAnonymous: state.constants.UserIsAnonymous,
    AnonymousUserEmail: state.entities.AnonymousUserEmail,
    POValue: entities.PONumber,
    OrderType: state.entities.OrderType,
    HasRestrictedItems: state.entities.HasRestrictedItems,
    SiteKey: state.constants.SiteKey
  };
}



// WEBPACK FOOTER //
// ./src/Components/checkout/Features/PlaceOrder/mapStateToPlaceOrderDetails.js